module.exports = __webpack_public_path__ + "static/img/aphv.b925a5f8.svg";